import {
  fetchProfile,
  postProfile,

  fetchPassport,
  postPassport,

  fetchAddress,
  postAddress,

  fetchPassportAddress,
  postPassportAddress,

  fetchVehicles,
  postVehicle,

  postDeviceName,

  postContract,

  fetchConfidants,
} from './actions';
import {
  editProfileClick,
  editAddressClick,
  editPassportAddressClick,
  editPassportClick,
} from '../../components/Modal/SettingsModal/ProfileSettings/actions';
import { fetchDevices } from '../devices/actions';
import { editVehicleClick, editDeviceNameClick, editDeviceNameSave } from '../../components/Modal/SettingsModal/VehiclesSettings/actions';
import { login } from '../auth/actions';
import { signContract } from '../../components/Auth/actions';
import { delay } from 'redux-saga';
import { take, call, fork, select, cancel, cancelled, put } from 'redux-saga/effects';
import { apiRequest } from '../../utils/api';
import { bindAsyncAction } from '../../utils/sagas';
import { logoutButtonClick } from '../../components/Auth/actions'

const worker = (action, options) => {
  return bindAsyncAction(
    action,
    function* load(params = options) {
      return yield call(apiRequest, params);
    }
  );
};

const vehiclesWorker = bindAsyncAction(
  fetchVehicles,
  function* load(params) {
    return yield call(apiRequest, params);
  }
);

const confidantsWorker = bindAsyncAction(
  fetchConfidants,
  function* load(params) {
    return yield call(apiRequest, params);
  }
);

export default function* settingsSaga() {
  while(true) {

    yield take(login.done.type);
    const profile = yield fork(profileSaga);



    const passport = yield fork(passportSaga);

    const address = yield fork(addressSaga);
    const passportAddress = yield fork(passportAddressSaga);
    const deviceName = yield fork(deviceNameSaga);
    const sighContract = yield fork(signContractSaga);

    yield take(fetchDevices.done.type);

    const vehicles = yield fork(vehiclesSaga);
    const confidants = yield fork(confidantsSaga);

    yield take(logoutButtonClick.type);

    yield cancel(profile);
    yield cancel(passport);
    yield cancel(address);
    yield cancel(passportAddress);
    yield cancel(deviceName);
    yield cancel(sighContract);
    yield cancel(vehicles);
    yield cancel(confidants);
  }
}

function* signContractSaga() {
  while (true) {
    yield take(signContract.type);
    const vehicleId = yield select(state => state.settings.vehicles[0].id);
    const packageId = localStorage.getItem('packageId');
    const postContractWorker = worker(postContract, {
      url: '/api/v2/contracts',
      method: 'PUT',
      body: JSON.stringify({
        vehicleId,
        packageId,
        utcOffsetHours: new Date().getTimezoneOffset(),
      }),
    });
    try {
      yield call(postContractWorker);
      yield delay(4000);
      const devicesWorker = worker(fetchDevices, {
        url: '/api/v3/devices',
        method: 'GET',
      });
      yield call(devicesWorker);
    } catch (e) {
      continue;
    }
  }
}

function* profileSaga() {
  try {
    const fetchWorker = worker(fetchProfile, {
      url: '/api/v2/Profile',
    });
    yield call(fetchWorker);
  } catch (e) {
    void 0;
  }

  while (true) {
    const { payload } = yield take(editProfileClick.type);
    const profile = yield select(state => state.settings.profile);
    const data = {
      ...profile,
      ...payload.profile,
    };

    try {
      const postWorker = worker(postProfile, {
        url: '/api/v2/Profile',
        method: payload.profile.isNew ? 'PUT' : 'POST',
        body: JSON.stringify(data),
      });
      yield call(postWorker);
    } catch (e) {
      continue;
    }
  }
}

function* passportSaga() {
  try {
    const fetchWorker = worker(fetchPassport, {
      url: '/api/v2/passport',
    });
    yield call(fetchWorker);
  } catch (e) {
  }

  while (true) {
    const { payload } = yield take(editPassportClick.type);
    const { passport } = payload;
    const dateParts = passport.issueDate.split('.');
    if (dateParts.length) {
      passport.issueDate = {
        year: dateParts[2],
        month: dateParts[1],
        day: dateParts[0],
      };
    } else {
      passport.issueDate = null;
    }

    try {
      const postWorker = worker(postPassport, {
        url: '/api/v2/passport',
        method: payload.passport.isNew ? 'PUT' : 'POST',
        body: JSON.stringify(payload.passport),
      });
      yield call(postWorker);
    } catch (e) {
      continue;
    }
  }
}

function* addressSaga() {
  try {
    const fetchWorker = worker(fetchAddress, {
      url: '/api/v2/address',
    });
    yield call(fetchWorker);
  } catch (e) {
  }

  while (true) {
    const { payload } = yield take(editAddressClick.type);

    try {
      const postWorker = worker(postAddress, {
        url: '/api/v2/address',
        method: payload.address.isNew ? 'PUT' : 'POST',
        body: JSON.stringify(payload.address),
      });
      yield call(postWorker);
    } catch (e) {
      continue;
    }
  }
}

function* passportAddressSaga() {
  try {
    const fetchWorker = worker(fetchPassportAddress, {
      url: '/api/v2/passport/address',
    });
    yield call(fetchWorker);
  } catch (e) {
  }

  while (true) {
    const { payload } = yield take(editPassportAddressClick.type);

    try {
      const postWorker = worker(postPassportAddress, {
        url: '/api/v2/passport/address',
        method: payload.address.isNew ? 'PUT' : 'POST',
        body: JSON.stringify(payload.address),
      });
      yield call(postWorker);
    } catch (e) {
      continue;
    }
  }
}

function* vehiclesSaga() {
  const devicesIds = yield select(state => state.devices.devices.map(d => d.id));
  for (const deviceId of devicesIds) {
    try {
      yield call(vehiclesWorker, {
        method: 'POST',
        url: '/api/v2/vehicles',
        body: JSON.stringify({deviceId}),
      });
    } catch (e) {
    }
  }

  while (true) {
    const { payload } = yield take(editVehicleClick.type);

    try {
      const postWorker = worker(postVehicle, {
        url: payload.vehicle.isNew ? '/api/v2/vehicles' : `/api/v2/vehicles/${payload.vehicle.id}`,
        method: payload.vehicle.isNew ? 'PUT' : 'POST',
        body: JSON.stringify(payload.vehicle),
      });
      yield call(postWorker);
    } catch (e) {
      continue;
    }
  }
}

function* deviceNameSaga() {
  while (true) {
    const { payload } = yield take(editDeviceNameClick.type);

    try {
      const postWorker = worker(postDeviceName, {
        url: `/api/v3/Devices/${payload.deviceId}/customName`,
        method: 'POST',
        body: JSON.stringify(payload.name),
      });
      yield call(postWorker);
      yield put({
        type: editDeviceNameSave.type,
        payload,
      });
    } catch (e) {
      continue;
    }
  }
}

function* confidantsSaga() {
  const devicesIds = yield select(state => state.devices.devices.map(d => d.id));
  for (const deviceId of devicesIds) {
    try {
      yield call(confidantsWorker, {
        method: 'POST',
        url: '/api/v3/confidants',
        body: JSON.stringify({deviceId: deviceId}),
      });
    } catch (e) {
      if(yield cancelled()) {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/settings/index.js